import React,{ Component } from 'react'
import ReactDOM from 'react-dom'
import './toast.css';
import successIcon from './img/success.svg'
import errorIcon from './img/error.svg'
import warningIcon from './img/warning.svg'
import infoIcon from './img/info.svg'
class Toast extends Component {
    constructor(){
        super();
        this.state = {
            notices:[],
            iconObj: {
                info: infoIcon,
                success: successIcon,
                error: errorIcon,
                warning: warningIcon
            }
        }
    }
    
    getNoticeKey = ()=>{
        return `notice:${new Date().getTime()}:${this.state.notices.length}`;
    }

    addNotice = (notice) =>{
        const { notices } = this.state;
        const key = notice.key ? notice.key : notice.key = this.getNoticeKey();
        const temp = notices.filter((item) => item.key === key).length;
        if(temp === 0){
            notices.push(notice);
            this.setState({
                notices,
            })
        }
        if (notice.duration > 0) {
            setTimeout(() => {
                this.removeNotice(notice.key)
            }, notice.duration);
        }
    }

    removeNotice = (key)=>{
        let { notices } = this.state;
        notices = notices.filter((item)=>{
            return item.key !== key
        })
        this.setState({
            notices
        })
    }

    render(){
        const { notices,iconObj } = this.state
        return (
            notices.length > 0 ?
            <div className="toast">
                {notices.map(item=>(
                    <div className={`toast-inner`} key={item.key}>
                        <p className="toast-text"><img className={`toast-icon`} src={iconObj[item.type]} alt=""/>{item.text}</p>
                    </div>
                ))}
            </div>: null
        )
    }
}

function createToast(){
    const div = document.createElement('div');
    document.body.appendChild(div)
    const ref = React.createRef()
    ReactDOM.render(<Toast ref={ref}/>,div)

    return {
        add(notice){ return ref.current.addNotice(notice)},
        destroy(){
            ReactDOM.unmountComponentAtNode(div)
            document.body.removeChild(div)
        }
    }
}

export default createToast()